/* eslint-disable react-hooks/exhaustive-deps */
import isEmpty from 'lodash/isEmpty';
import {
    useEffect,
    useState,
    createContext,
    useContext,
} from 'react';

import { getAlmostDoneEntries } from '../../../commons/images';
import { useEnvStore } from '../env';

import { ENDPOINT_HOST } from '../../../commons/utils/constants';
import { attachScheduleFilteringParams } from '../../../commons/params';

export const UIStatesContext = createContext();

/*
 * this will be a good place to manage large size  state data.
 * use sparigingly,
 * use on list or maps that often change
 */

function correctActiveInputCursor (p) {
    const {
        cursorPositions,
        cursorTarget,
    } = p;
    // reposition after state take place

    if (cursorPositions && cursorTarget) {
        const {
            element,
            field,
            // selector,
        } = cursorTarget;
        const pos = cursorPositions[field];
        if (element && pos && pos.start && pos.end) {
            element.setSelectionRange(pos.start,pos.end);
        }
    };
}

function initializeFieldValues (values) {
    const email = document.getElementById('email');
    if (email) {
        email.value = values.email;
    }

    /*
        Unbind states: Email, FirstName, LastName, Custom Field: Text Entry.
        // TODO: Workaround for unbind states to the input fields: EBL-9910
        const firstName = document.getElementById('first_name');
        const lastName = document.getElementById('last_name');
        if (firstName) {
            firstName.value = values.first_name;
        }
        if (lastName) {
            lastName.value = values.last_name;
        }
    */
}

export function useUIStatesManager (p) {
   
    const {
        /* contains all stores */
        store,
    } = p;
    const env = useEnvStore();
    const appStore = store.appStore;
    const uistatesStore = store.uiStatesStore;
    const schedulesStore = store.schedulesStore;
    const [fieldErrors, setFieldErrors] = useState({});
    const [subscribersFields, setSubscribersFields] = useState({});
    const [cursorPositions, setCursorPositions] = useState({});

    const [customValues, setCustomValues] = useState({});
    const [optinValues, setOptinValues] = useState({});
    const [touched, setTouched] = useState({});
    const [isRequiredFilledIn, setIsRequiredFilledIn] = useState(false);
    const [selectedSchedules, setSelectedSchedules] = useState({});
    const [selectedCalendar, setSelectedCalendar] = useState('google');
    const selectedCalApp = selectedCalendar === 'outlook-new' ? 'outlook' : selectedCalendar;
    const [isDirectLink, setIsDirectLink] = useState(appStore.directLink);
    const [deviceInfo, setDeviceInfo] =  useState({});
    const [shareMessageUrl, setShareMessageUrl] = useState('');

    function captureDeviceInfo () {
        const ua = appStore.userAgent;
        let os = 'other';
        let browser = '';

        if (ua) {
            os = ua.os.name;
            browser = ua.browser.name; 
        }  

        const {
            guideImage,
            dataPlatform,
        } = getAlmostDoneEntries(os, browser);
        
        setDeviceInfo({
            guideImage,
            dataPlatform,
            os,
            browser,
        });
    }

    function captureShareMessageUrl () {
        let url = '';

        // if BE does not send a shareMessageUrl, use the direct link or manupulate from params for preview mode
        if (isEmpty(appStore?.widget?.shareMessageUrl)) {
            if (appStore.directLink) {
                url = `${env.page.completePath}&`;
            } else {
                const endPointHost = ENDPOINT_HOST[env.Environment];
                const widgetId = appStore?.widget?.id;
                const apikey = appStore?.widgetSettings?.apikey;
                const params = env.page.params;
                const scheduleFilteringParam = attachScheduleFilteringParams(params);
                url = `${endPointHost}/loading?widgetId=${widgetId}&apiKey=${apikey}${scheduleFilteringParam}`;
            }
        } else {
            // if BE sends a shareMessageUrl, use it
            url = appStore?.widget?.shareMessageUrl;
        }

        // console.log('useUIStatesManager.captureShareMessageUrl() -> url: ', url);
        setShareMessageUrl(url);
    }

    useEffect(() => {
        captureDeviceInfo();
    }, [appStore.observed.userAgent]);

    useEffect(() => {
        setIsDirectLink(appStore.directLink);
    }, [appStore.observed.directLink]);

    useEffect(() => {
        if (!isEmpty(appStore?.widget) && !appStore.widget.shareDisabled) {
            captureShareMessageUrl();
        }
    }, [appStore.observed.widget]);

    useEffect(() => {
        setFieldErrors(uistatesStore.fieldErrors);
    }, [uistatesStore.observed.fieldErrors]);

    useEffect(() => {
        setIsRequiredFilledIn(uistatesStore.isRequiredFilledIn);
    }, [uistatesStore.observed.isRequiredFilledIn]);
 
    useEffect(() => {
        setSubscribersFields(uistatesStore.subscribersFields);
    }, [uistatesStore.observed.subscribersFields]);

    useEffect(() => {
        setCursorPositions(uistatesStore.cursorPositions);
    }, [uistatesStore.observed.cursorPositions]);

    useEffect(() => {
        setCustomValues(uistatesStore.customValues);
    }, [uistatesStore.observed.customValues]);

    useEffect(() => {
        setOptinValues(uistatesStore.optinValues);
    }, [uistatesStore.observed.optinValues]);

    useEffect(() => {
        setTouched(uistatesStore.touchedFields);
    }, [uistatesStore.observed.touchedFields])

    useEffect(() => {
        setSelectedSchedules(schedulesStore.selectedSchedules);
    }, [schedulesStore.observed.selectedSchedules]);

    useEffect(() => {
        setSelectedCalendar(uistatesStore.selectedCalendar);
    }, [uistatesStore.observed.selectedCalendar]);
    

    useEffect(() => {
        correctActiveInputCursor({
            cursorPositions: uistatesStore.cursorPositions,
            cursorTarget: uistatesStore.cursorTarget,
        });
    }, [subscribersFields, customValues]);

    function updateSubscribersFields (obj, options) {
        uistatesStore.setSubscribersFields(obj, options);
    }

    function updateCustomValues (obj, options) {
        uistatesStore.updateCursorTarget(options);
        uistatesStore.updateCustomValues(obj);
    }

    function updateOptinValues (obj) {
        uistatesStore.updateOptinValues(obj);
    }

    function hasErrors () {
        if (isEmpty(fieldErrors)) {
            return true;
        }
        return false;
    }

    function initializeUIValues () {
        initializeFieldValues(subscribersFields);
    }

    function dispatchError (error) {
        env.errorsStore.dispatch(error);
        appStore.gotoErrors();
    }

    return {
        appStore,
        statesStore: uistatesStore,
        fieldErrors,
        subscribersFields,
        setSubscribersFields: updateSubscribersFields,
        updateCustomValues,
        updateOptinValues,
        customValues,
        optinValues,
        touched,
        isRequiredFilledIn,
        selectedSchedules,
        selecteDeselectSchedule: (id) => schedulesStore.selecteDeselectSchedule(id),
        selectCalendar: (calendar) => uistatesStore.selectCalendar(calendar),
        captureFields: () =>  uistatesStore.captureFields(),
        selectedCalendar,
        selectedCalApp,
        deviceInfo,
        hasErrors,
        isDirectLink,
        dispatchError,
        cursorPositions,
        initializeUIValues,
        shareMessageUrl,
    };
}

function useUIStates () {
    const uiStates = useContext(UIStatesContext);
    return {
        ...uiStates,
    };
}

export default useUIStates;